// removed by extract-text-webpack-plugin
module.exports = {"container":"_2Txy4nSFH_sf5IPbN3cjdb","iconContainer":"_1F8Sz3Higik_smeuGdYUeh","icon":"_3JlXHlWiUBExLoqvUl-O7W","megascans":"_1MX4Ct7ICFUAYehON-ZK_","unreal":"_1LpJ9KkO2ED6ypGoWY_tsI","heading":"_1G74ZFTvNw6SOiQDaOoBft","para":"_3vl3JgLJCunEPjNytW_Ylx","actionButton":"_3-XR4WCw_bIZ_YdP_4VBSS","footer":"G7MH9mX3DquXRiGE953dS"};


//////////////////
// WEBPACK FOOTER
// ./src/EpicEula/TrialPopup/styles.scss
// module id = 1249
// module chunks = 0